var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as freelancerAction from '../actions/freelancer.action';
import { switchMap, mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { FreelancersService } from '../../freelancers.service';
import { isNullOrUndefined } from 'util';
var FreelancerEffect = /** @class */ (function () {
    function FreelancerEffect(actions, store, freelancerService) {
        var _this = this;
        this.actions = actions;
        this.store = store;
        this.freelancerService = freelancerService;
        this.getAllFreelancers = this.actions.ofType(freelancerAction.GET_ALL_FREELANCERS)
            .pipe(switchMap(function () {
            return _this.freelancerService.getAllFreelancers()
                .map(function (res) { return new freelancerAction.GetAllFreelancersSuccess(res); })
                .catch(function (error) { return of(new freelancerAction.GetAllFreelancersError(error)); });
        }));
        this.getFreelancer = this.actions.ofType(freelancerAction.GET_FREELANCER)
            .pipe(withLatestFrom(
        // select users.
        this.store.select(function (state) { return state.freelancersFeature.freelancers; }), function (action, freelancers) {
            // if no users present, proceed for API.
            if (isNullOrUndefined(freelancers.users)) {
                return action;
            }
            else {
                // users exists in store.
                var user = freelancers.users.filter(function (f) { return f.id === action.payload; })[0];
                if (!!user) {
                    // if required user is present in store, then return;
                    return undefined;
                }
                else {
                    // if required user not present in store, then proceed for API.
                    return action;
                }
            }
        }), filter(function (action) { return !!action; }), mergeMap(function (action) {
            return _this.freelancerService.getFreelancer(action.payload)
                .map(function (res) { return new freelancerAction.GetFreelancerSuccess(res); })
                .catch(function (error) { return of(new freelancerAction.GetFreelancerError(error)); });
        }));
        this.registerFreelancer = this.actions.ofType(freelancerAction.ADD_FREELANCER)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.freelancerService.registerFreelancer(body)
                .map(function (res) { return new freelancerAction.AddFreelancerSuccess(res); })
                .catch(function (error) { return of(new freelancerAction.AddFreelancerError(error)); });
        }));
        this.updateFreelancer = this.actions.ofType(freelancerAction.UPDATE_FREELANCER)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.freelancerService.updateFreelancer(body)
                .map(function (res) { return new freelancerAction.UpdateFreelancerSuccess(res); })
                .catch(function (error) { return of(new freelancerAction.UpdateFreelancerError(error)); });
        }));
        this.deleteFreelancer = this.actions.ofType(freelancerAction.DELETE_FREELANCER)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.freelancerService.deleteFreelancer(body)
                .map(function (res) { return new freelancerAction.DeleteFreelancerSuccess(res); })
                .catch(function (error) { return of(new freelancerAction.DeleteFreelancerError(error)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], FreelancerEffect.prototype, "getAllFreelancers", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], FreelancerEffect.prototype, "getFreelancer", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], FreelancerEffect.prototype, "registerFreelancer", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], FreelancerEffect.prototype, "updateFreelancer", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], FreelancerEffect.prototype, "deleteFreelancer", void 0);
    return FreelancerEffect;
}());
export { FreelancerEffect };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/freelancers/store/effects/freelancer.effect.ts.pre-build-optimizer.js